import clsx from "clsx"

import useSlugExtractor from "@hooks/useSlugExtractor"

import getClientTypeIcon from "@utils/getClientTypeIcon"

import { TruncatableText } from "@particles"
import Skeleton from "@particles/Skeleton/Skeleton"

import { Avatar, NavigationLink } from "@atoms"

import { CLIENTS_ROUTES } from "@routes/clients"

import styles from "./ClientLocationCard.module.scss"
import { ClientLocationCardProps } from "./ClientLocationCard.types"

export default function ClientLocationCard(props: ClientLocationCardProps) {
    const {
        clientId,
        clientName,
        clientTypeLabel,
        serviceLocationName,
        serviceLocationAddress,
        isLoading = false,
        className,
    } = props

    const [clientDetailsRoute] = useSlugExtractor([CLIENTS_ROUTES.DETAILS], clientId)

    if (isLoading) {
        return (
            <div className={clsx(styles.base, styles.loading, className)}>
                <div className={styles.avatar}>
                    <Skeleton width={36} height={36} borderRadius={8} />
                </div>
                <div className={styles.content}>
                    <div className={styles.skeletonLineTop}>
                        <Skeleton width={128} height={10} borderRadius={0} />
                    </div>
                    <div className={styles.skeletonLineBottom}>
                        <Skeleton width="100%" height={10} borderRadius={0} />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <NavigationLink
            path={clientDetailsRoute}
            title={clientName}
            openIn="newTab"
            className={clsx(styles.base, className)}
        >
            {() => (
                <>
                    <Avatar variant="object" icon={getClientTypeIcon(clientTypeLabel)} size="xl" />
                    <div className={styles.content}>
                        <TruncatableText text={clientName} tooltipOnTruncate={true} className={styles.clientName} />
                        <div className={styles.locationInfo}>
                            {serviceLocationName && <span className={styles.locationName}>{serviceLocationName}</span>}
                            {serviceLocationName && serviceLocationAddress && (
                                <span className={styles.separator}>&bull;</span>
                            )}
                            {serviceLocationAddress && (
                                <TruncatableText
                                    text={serviceLocationAddress}
                                    tooltipOnTruncate={true}
                                    className={styles.address}
                                />
                            )}
                        </div>
                    </div>
                </>
            )}
        </NavigationLink>
    )
}
